/**
 * Tháng thực hiện
 */
export default {
  Year: 0, // năm
  January: 1, // Tháng 1
  February: 2, // Tháng 2 
  March: 3, // Tháng 3
  April: 4, // Tháng 4
  May: 5, // Tháng 5
  June: 6, // Tháng 6
  July: 7, // Tháng 7
  August: 8, // Tháng 8
  September: 9, // Tháng 9
  October: 10, // Tháng 10
  November: 11, // Tháng 11
  December: 12, // Tháng 12
  QuarterI: 13, // Quý I (Tháng 1, 2, 3)
  QuarterII: 14, // Quý II (Tháng 4, 5, 6)
  QuarterIII: 15, // Quý III (Tháng 7, 8, 9)
  QuarterIV: 16, // Quý IV (Tháng 10, 11, 12)
  
};
